var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-button mr-3",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{staticClass:"navbar-button-icon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }